import _regenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _slicedToArray from "/usr/app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import React from "react";
var __jsx = React.createElement;
import Button from "../../../../../../components/UiKit/Button/Button";
import BackButton from "../../../../../../components/UiKit/Buttons/BackButton/BackButton";
import { useState } from "react";
import { useTranslation } from "@i18n";
import useFormValidation from "@hooks/useFormValidation";
import stl from "./UserEditMobileComponent.module.css";
import OtpVerification from "@/_MiniApps/auth/ui/OTP/OtpVerification";
import { useAuthActions, useSession } from "@/_MiniApps/auth/AuthContext";
import useHelpers from "@hooks/useHelpers";
import { ValidationException } from "@/common/exceptions/ValidationException";
import useButtonLoading from "@hooks/useButtonLoading";
import useAlertsToaster from "@hooks/useAlertsToaster";
import InputPhoneNumber from "@componentsShared/InputPhoneNumber/InputPhoneNumber";
var UserEditMobileComponent = function UserEditMobileComponent() {
  var _useTranslation = useTranslation(["web_common", "web_user_account"]),
    t = _useTranslation.t,
    tShort = _useTranslation.tShort;
  var _useSession = useSession(),
    user = _useSession.user;
  var buttonLoading = useButtonLoading();
  var _useState = useState(user === null || user === void 0 ? void 0 : user.phone_number),
    mobile = _useState[0],
    setMobile = _useState[1];
  var _useState2 = useState(""),
    errorMessage = _useState2[0],
    setErrorMessage = _useState2[1];
  var _useState3 = useState("EditMobile"),
    step = _useState3[0],
    setStep = _useState3[1];
  var _useHelpers = useHelpers(),
    navigateTo = _useHelpers.navigateTo;
  var _useAuthActions = useAuthActions(),
    remote_updateUserMobileProfile = _useAuthActions.remote_updateUserMobileProfile;
  var _useAlertsToaster = useAlertsToaster(),
    successToast = _useAlertsToaster.successToast;
  var _useFormValidation = useFormValidation([{
      field: "phone_number",
      value: mobile,
      oldValue: user === null || user === void 0 ? void 0 : user.phone_number,
      validation: [{
        name: "required",
        message: t("validation_mobile_number_empty", {
          ns: "web_user_account"
        })
      }, {
        name: "phoneNumber",
        message: t("validation_mobile_number_start_05", {
          ns: "web_user_account"
        })
      }, {
        name: "sameNumber",
        message: t("number_matches_current_mobile_number", {
          ns: "web_user_account"
        })
      }]
    }]),
    _useFormValidation2 = _slicedToArray(_useFormValidation, 2),
    errors = _useFormValidation2[0],
    validate = _useFormValidation2[1];
  var handleOnChange = function handleOnChange(e) {
    console.log("====================================");
    console.log(e.target.value);
    console.log("====================================");
    setMobile(e.target.value);
  };
  var handleSubmit = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      var _t;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.p = _context.n) {
          case 0:
            if (!validate()) {
              _context.n = 4;
              break;
            }
            _context.p = 1;
            _context.n = 2;
            return remote_updateUserMobileProfile(mobile);
          case 2:
            setStep("VerifyOtp");
            _context.n = 4;
            break;
          case 3:
            _context.p = 3;
            _t = _context.v;
            if (_t instanceof ValidationException) {
              setErrorMessage(_t.extractErrorMessageFrom(["phone_number"]));
            }
          case 4:
            return _context.a(2);
        }
      }, _callee, null, [[1, 3]]);
    }));
    return function handleSubmit() {
      return _ref.apply(this, arguments);
    };
  }();
  var verifyOtpCb = function verifyOtpCb() {
    successToast(t("mobile_number_modified_successfully", {
      ns: "web_user_account"
    }));
    navigateTo("/user/account/my-info");
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: stl.mainContainer
  }, /*#__PURE__*/React.createElement(BackButton, {
    className: [stl.mb16, "m-hide"].join(" "),
    onClick: function onClick() {
      return navigateTo("/user/account/my-info");
    }
  }, /*#__PURE__*/React.createElement("span", null, t("back", {
    ns: "web_common"
  }))), step === "EditMobile" && /*#__PURE__*/React.createElement("div", {
    className: stl.form
  }, /*#__PURE__*/React.createElement("h2", {
    className: stl.title
  }, t("edit_mobile_number", {
    ns: "web_user_account"
  })), /*#__PURE__*/React.createElement("p", {
    className: stl.subTitle
  }, t("send_verification_code_new_mobile", {
    ns: "web_user_account"
  })), /*#__PURE__*/React.createElement(InputPhoneNumber, {
    className: stl.mb40,
    defaultValue: mobile,
    onChange: function onChange(value) {
      // Create a synthetic event to simulate a standard React.ChangeEvent<HTMLInputElement>
      var syntheticEvent = {
        target: {
          name: "phone_number",
          // The name of the field
          value: value // The updated value
        }
      };
      handleOnChange(syntheticEvent);
    },
    errorLabel: errorMessage || (errors === null || errors === void 0 ? void 0 : errors.phone_number) || ""
  }), /*#__PURE__*/React.createElement("div", {
    className: stl.button
  }, /*#__PURE__*/React.createElement(Button, {
    type: "submit",
    onClick: handleSubmit,
    disabled: buttonLoading,
    className: ["blueBtn", stl.blueButtonDesign].join(" ")
  }, buttonLoading ? /*#__PURE__*/React.createElement("span", {
    className: stl.loader
  }) : t("send_verification_code", {
    ns: "web_user_account"
  })))), step === "VerifyOtp" && /*#__PURE__*/React.createElement(OtpVerification, {
    forceSend: true,
    source: "update_phone",
    after_verify_callback: verifyOtpCb,
    scenario: "update_phone",
    phone_number: mobile,
    onEditNumber: function onEditNumber() {
      setStep("EditMobile");
      setErrorMessage("");
    },
    design: {
      className: stl.form,
      subClassName: stl.fontSize,
      btnText: tShort("phone_number_verification", {
        "ns": "otp_screen"
      }),
      label: tShort("enter_code_sent_to", {
        "ns": "otp_screen"
      })
    }
  })));
};
export default UserEditMobileComponent;